import { Notification, useToast } from "@zendeskgarden/react-notifications";
import { NotificationProps } from "./notificationType";

export function useNotification() {
  const { addToast } = useToast();

  const showNotification = ({ type = "info", title, message}: NotificationProps) => {
    addToast(
      ({ close }) => (
        <Notification type={type} style={{ maxWidth: 450, marginTop: -50 }}>
          <Notification.Title>{title}</Notification.Title>
          {message}
          <Notification.Close aria-label="Fechar" onClick={close} />
        </Notification>
      ),
      { placement:"top-end"}
    );
  };

  return { showNotification };
}
